var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61046 16.9449C8.61046 17.4051 8.23736 17.7782 7.77713 17.7782H7.49935C5.81181 17.7782 4.44379 16.4102 4.44379 14.7226V4.44488C4.44379 4.13805 4.19506 3.88932 3.88824 3.88932C3.428 3.88932 3.0549 3.51623 3.0549 3.05599C3.0549 2.59575 3.428 2.22266 3.88824 2.22266H13.3327C14.56 2.22266 15.5549 3.21758 15.5549 4.44488V13.6115C15.5549 14.0718 15.1818 14.4449 14.7216 14.4449C14.2613 14.4449 13.8882 14.0718 13.8882 13.6115V4.44488C13.8882 4.13805 13.6395 3.88932 13.3327 3.88932H6.04045C6.08615 4.06689 6.11046 4.25305 6.11046 4.44488V14.7226C6.11046 15.4897 6.73229 16.1115 7.49935 16.1115H7.77713C8.23736 16.1115 8.61046 16.4846 8.61046 16.9449Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77713 6.38931C7.77713 5.92908 8.15022 5.55598 8.61046 5.55598H11.3882C11.8485 5.55598 12.2216 5.92908 12.2216 6.38931C12.2216 6.84955 11.8485 7.22265 11.3882 7.22265H8.61046C8.15022 7.22265 7.77713 6.84955 7.77713 6.38931Z",
    fill: "#71869D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77713 9.72265C7.77713 9.26241 8.15022 8.88931 8.61046 8.88931H11.3882C11.8485 8.88931 12.2216 9.26241 12.2216 9.72265C12.2216 10.1829 11.8485 10.556 11.3882 10.556H8.61046C8.15022 10.556 7.77713 10.1829 7.77713 9.72265Z",
    fill: "#71869D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 4.44487C1.66602 3.21757 2.66094 2.22266 3.88824 2.22266C5.11554 2.22266 6.11046 3.21758 6.11046 4.44488V8.61154C6.11046 9.07177 5.73736 9.44487 5.27713 9.44487H2.49935C2.03911 9.44487 1.66602 9.07177 1.66602 8.61154V4.44487ZM3.88824 3.88932C3.58141 3.88932 3.33268 4.13805 3.33268 4.44487V7.7782H4.44379V4.44488C4.44379 4.13805 4.19506 3.88932 3.88824 3.88932Z",
    fill: "#71869D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88824 13.6115C8.88824 13.1513 9.26133 12.7782 9.72157 12.7782H17.7771C18.2374 12.7782 18.6105 13.1513 18.6105 13.6115V15.2782C18.6105 16.6589 17.4912 17.7782 16.1105 17.7782H7.49935C7.03911 17.7782 6.66602 17.4051 6.66602 16.9449C6.66602 16.4846 7.03911 16.1115 7.49935 16.1115C8.26641 16.1115 8.88824 15.4897 8.88824 14.7226V13.6115ZM10.2217 16.1115H16.1105C16.5707 16.1115 16.9438 15.7384 16.9438 15.2782V14.4449H10.5549V14.7226C10.5549 15.2228 10.4348 15.6948 10.2217 16.1115Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContract);
export default __webpack_public_path__ + "static/media/iconContract.aac8082c5fdc971e6fb3e7e9c3fa075b.svg";
export { ForwardRef as ReactComponent };